import React from 'react';
import { Typography } from 'fronton-react';

export const PopularButton = () => (
	<Typography variant="s" size="body_long" data-qa="popular-btn-content">
		Узнать больше
	</Typography>
);
